import React from "react";
import CardHeaderLabel from "./CardHeaderLabel";

const RegularUserChatDockCard = () => {
  return (
    <div className="flex h-full flex-col text-white">
      <CardHeaderLabel label="Chat" className="text-white" />
      <div className="flex flex-1 flex-col gap-4 px-4 pb-4">
        <p className="text-sm text-white/80">
          The red card will soon host a full chat experience. For now, preview
          the card layout and return to the blog for live updates.
        </p>
        <div className="rounded-xl border border-white/20 bg-white/10 p-4 text-sm">
          Tap or click this card to feel the shudder animation and see the
          coming soon message.
        </div>
        <p className="mt-auto text-xs text-white/60">
          Coming soon to Carline Consensor.
        </p>
      </div>
    </div>
  );
};

export default RegularUserChatDockCard;
